"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskManagerProvider = exports.TaskManagerContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _TaskManager = require("./TaskManager.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TaskManagerContext = exports.TaskManagerContext = /*#__PURE__*/_react.default.createContext({});
const TaskManagerProvider = _ref => {
  let {
    children
  } = _ref;
  //const isActive = useRef(false);

  const {
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const getLabel = (0, _hooks.useLabels)({
    labels: _TaskManager.labels
  });
  const {
    isMobileView,
    isMobile
  } = (0, _hooks.useDeviceData)();
  const [isPopupOpen, setIsPopupOpen] = (0, _react.useState)(true);
  const [isChanged, setIsChanged] = (0, _react.useState)(false);
  const [isUpdate, setIsUpdate] = (0, _react.useState)(false);
  const [unitData, setUnitData] = (0, _react.useState)(null);
  const [isUnitDataLoading, setIsUnitDataLoading] = (0, _react.useState)(true);
  const [isUnitDataError, setIsUnitDataError] = (0, _react.useState)(false);
  const [task, setTask] = (0, _react.useState)(null);
  const [originalTask, setOriginalTask] = (0, _react.useState)(null);
  const [isTaskLoading, setIsTaskLoading] = (0, _react.useState)(true);
  const [taskError, setTaskError] = (0, _react.useState)(false);
  const [isCloneItem, setIsCloneItem] = (0, _react.useState)(false);
  const [isCloneItemError, setIsCloneItemError] = (0, _react.useState)(false);
  const [isSavingItem, setIsSavingItem] = (0, _react.useState)(false);
  const [isSavedItem, setIsSavedItem] = (0, _react.useState)(false);
  const [isSaveItemError, setIsSaveItemError] = (0, _react.useState)(false);
  const [isShareItem, setIsShareItem] = (0, _react.useState)(false);
  const [onCloseData, setOnCloseData] = (0, _react.useState)(null);
  const [editTaskDataName, setEditTaskDataName] = (0, _react.useState)('');
  const [editTaskDataGuideLines, setEditTaskDataGuideLines] = (0, _react.useState)('');
  const [isEditTaskDataChanged, setIsEditTaskDataChanged] = (0, _react.useState)(false);
  const [isEditTaskDataOpened, setIsEditTaskDataOpened] = (0, _react.useState)(false);
  const [updateTaskTypeAfterExamStart, setUpdateTaskTypeAfterExamStart] = (0, _react.useState)(false);
  const [isChangedBackToExam, setIsChangedBackToExam] = (0, _react.useState)(false);
  const [reSubmitTaskAfterTaskTypeChanged, setReSubmitTaskAfterTaskTypeChanged] = (0, _react.useState)(false);
  const [readOnlyGroups, setReadOnlyGroups] = (0, _react.useState)([]);
  const [readOnlyStudents, setReadOnlyStudents] = (0, _react.useState)([]);
  const [selectedGroups, setSelectedGroups] = (0, _react.useState)([]);
  const [selectedStudents, setSelectedStudents] = (0, _react.useState)([]);
  const [isGroupsReadOnly, setIsGroupsReadOnly] = (0, _react.useState)(false);
  const [showReadOnlyMessageTiming, setShowReadOnlyMessageTiming] = (0, _react.useState)(null);
  const [showReadOnlyMessageGroups, setShowReadOnlyMessageGroups] = (0, _react.useState)(null);
  const value = {
    // isActive: isActive,

    getLabel,
    language,
    isMobileView,
    isMobile,
    isPopupOpen,
    setIsPopupOpen,
    isChanged,
    setIsChanged,
    isUpdate,
    setIsUpdate,
    unitData,
    setUnitData,
    isUnitDataLoading,
    setIsUnitDataLoading,
    isUnitDataError,
    setIsUnitDataError,
    task,
    setTask,
    originalTask,
    setOriginalTask,
    isTaskLoading,
    setIsTaskLoading,
    taskError,
    setTaskError,
    isCloneItem,
    setIsCloneItem,
    isCloneItemError,
    setIsCloneItemError,
    isSavingItem,
    setIsSavingItem,
    isSavedItem,
    setIsSavedItem,
    isSaveItemError,
    setIsSaveItemError,
    isShareItem,
    setIsShareItem,
    onCloseData,
    setOnCloseData,
    editTaskDataName,
    setEditTaskDataName,
    editTaskDataGuideLines,
    setEditTaskDataGuideLines,
    isEditTaskDataChanged,
    setIsEditTaskDataChanged,
    isEditTaskDataOpened,
    setIsEditTaskDataOpened,
    updateTaskTypeAfterExamStart,
    setUpdateTaskTypeAfterExamStart,
    isChangedBackToExam,
    setIsChangedBackToExam,
    reSubmitTaskAfterTaskTypeChanged,
    setReSubmitTaskAfterTaskTypeChanged,
    readOnlyGroups,
    setReadOnlyGroups,
    readOnlyStudents,
    setReadOnlyStudents,
    selectedGroups,
    setSelectedGroups,
    selectedStudents,
    setSelectedStudents,
    isGroupsReadOnly,
    setIsGroupsReadOnly,
    showReadOnlyMessageTiming,
    setShowReadOnlyMessageTiming,
    showReadOnlyMessageGroups,
    setShowReadOnlyMessageGroups
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TaskManagerContext.Provider, {
    value: value,
    children: children
  });
};
exports.TaskManagerProvider = TaskManagerProvider;